export default __webpack_public_path__ + "static/media/commuter.02455deb.glb";